import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function updateUserMobile(payload) {
  try {
    const url = paths.updateUserMobile(); 
    const response = await axiosInstance.post(url, payload); 
    return response.data; 
  } catch (error) {
    return Promise.reject(error);
  }
}

const useUpdateUserMobile = () => {
  return useMutation({
    mutationFn: updateUserMobile, 
  });
};

export { useUpdateUserMobile };